/** Palette alignée sur App\Service\ProviderPlaceColorService::PALETTE */
export const PROVIDER_PLACE_COLOR_PALETTE = [
  '#1976d2',
  '#2e7d32',
  '#ed6c02',
  '#9c27b0',
  '#d32f2f',
  '#0288d1',
  '#00796b',
  '#f57c00',
  '#7b1fa2',
  '#c2185b',
  '#1565c0',
  '#388e3c',
  '#ef6c00',
  '#6a1b9a',
  '#ad1457',
] as const;

export function defaultProviderPlaceColorForIndex(index: number): string {
  const palette = PROVIDER_PLACE_COLOR_PALETTE;
  const i = Math.max(0, index);
  return palette[i % palette.length];
}

export function normalizeProviderPlaceColor(color: string | null | undefined): string | null {
  if (color == null) return null;
  const trimmed = color.trim();
  if (!/^#[0-9A-Fa-f]{6}$/.test(trimmed)) return null;
  return trimmed.toLowerCase();
}

export function resolveProviderPlaceColor(
  storedColor: string | null | undefined,
  placeId: number
): string {
  const normalized = normalizeProviderPlaceColor(storedColor);
  if (normalized) return normalized;
  return defaultProviderPlaceColorForIndex(Math.max(0, placeId - 1));
}
